<template>
    <div>
        <Backer v-if="showbacker != false" />
        <div class="">
            <div>
                <b-card>
                    <div style="font-size: 20px;">View Inventory</div>
                    <div style="display: block;">
                        <span style="display: inline-block; margin: 10px; width: 200px;">
                            <b-card-text>
                                <div>Location:</div>
                                <b-form-select
                                    v-model="location_id"
                                    :options="locations" 
                                    size="sm" 
                                ></b-form-select>
                            </b-card-text>
                        </span>

                        <span style="display: inline-block; margin: 10px; width: 200px;">
                            <b-card-text v-show="location_id != null">
                                <div>Sublocation:</div>
                                <b-form-select
                                    v-model="sublocation_id"
                                    :options="sublocations.filter(function(d) {return d.location_id == location_id})" 
                                    size="sm" 
                                    v-on:change="reset_inventory"
                                ></b-form-select>
                            </b-card-text>
                        </span>
                        
                        <span style="display: inline-block; margin: 10px; width: 200px;">
                            <b-button 
                                v-show="sublocation_id != null" 
                                size="sm" variant="primary"
                                :disabled="block_load_inventory"
                                @click="loadInventory"
                            >
                                Load Inventory
                            </b-button>
                        </span>
                    </div>

                    <div style="display: block;">

                        <div style="display: block; margin: 10px;">
                            <span style="display: inline-block; margin: 10px;">
                                <b-button
                                    v-show="sublocation_id != null" 
                                    size="sm" 
                                    variant="secondary"
                                    @click="initAddItems"
                                >
                                    <span v-if="init_add_items == false" > Add Item (Manual) </span>
                                    <span v-else style="color: white; font-weight: bold;"> Hide Add Item (Manual) </span>
                                </b-button>
                            </span>

                            <span style="display: inline-block; margin: 10px;">
                                <b-button
                                    v-show="sublocation_id != null" 
                                    size="sm" 
                                    variant="secondary"
                                    @click="initAddSpecialItems"
                                >
                                    <span v-if="init_add_special_items == false" > Add Special Item (Manual) </span>
                                    <span v-else style="color: white; font-weight: bold;"> Hide Add Special Item (Manual) </span>
                                </b-button>
                            </span>
                        </div>
                    </div>
                </b-card> 
            </div>

             <div style="margin-top: 10px;" v-show="location_id != null && sublocation_id != null && init_add_special_items == true">
                <b-card>
                    <div style="font-size: 20px;">Add Special Item</div>
                    <div>
                        <b-form @submit="addSpecialProduct">
                            <span style="display: inline-block; width: 250px;">
                                <b-card-text>
                                    <div>Product Name:</div> <b-form-input required v-model="special_product.product_name" size="sm"></b-form-input>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; width: 200px;">
                                <b-card-text>
                                    <div>SKU:</div> <b-form-input required v-model="special_product.sku" size="sm"></b-form-input>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; width: 150px;">
                                <b-card-text>
                                    <div>Vendor:</div> <b-form-input required v-model="special_product.vendor" size="sm"></b-form-input>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; width: 100px;">
                                <b-card-text>
                                    <div>Price:</div> <b-form-input required v-model="special_product.selling_price" type="number" min="1" step="0.1" size="sm"></b-form-input>
                                </b-card-text>
                            </span>

                             <b-button type="submit" variant="primary" size="sm">Add</b-button>
                        </b-form>
                    </div>
                </b-card>
            </div>

            <div style="margin-top: 10px;" v-show="location_id != null && sublocation_id != null && init_add_items == true">
                <b-card>
                    <div style="font-size: 20px;">Add New Items</div>
                    <div>
                        <b-form @submit="searchProducts">
                            <div style="margin-bottom: 10px;">
                                <span style="display: inline-block;">
                                    <b-form-input required size="sm" style="width: 500px;" v-model="search_keyword" placeholder="search a product / sku"></b-form-input>
                                </span>
                                <span style="display: inline-block;">
                                    <b-button type="submit" size="sm" variant="success" :disabled="block_search">Search</b-button>
                                    <b-button @click="searched_products=[]" size="sm" variant="dark" :disabled="block_search" >Clear</b-button>
                                </span>
                            </div>
                        </b-form>

                        <vue-good-table
                          v-show="searched_products.length > 0"
                          :columns="searched_products_columns"
                          @on-cell-click="onSearchedProductsColumnClick"
                          :rows="searched_products"
                          :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            position: 'top',
                            perPage: 5
                          }"
                          :search-options="{
                            enabled: false,
                            trigger: 'enter'
                          }"
                          :select-options="{ enabled: false }"
                          styleClass="vgt-table bordered condensed"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <span>
                                        <b-button variant="outline-success" size="sm">Add</b-button>
                                        <b-button variant="outline-primary" size="sm" style="visibility: hidden;"> </b-button>
                                    </span>
                                </span>

                                <span v-else-if="props.column.field == 'quantity'">
                                    <b-input size="sm" style="margin: auto; width: 100px;" v-model="searched_products[props.row.originalIndex].quantity" type="number"></b-input>
                                </span>

                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>
                            </template>
                        </vue-good-table>

                    </div>

                </b-card>
            </div>

            <div style="margin-top: 10px;">
                <b-card>
                    <div style="margin-bottom: 10px;">
                        <div style="font-size: 20px; display: inline-block;">Availables</div>
                        <div style="display: inline-block; float: right;">

                            <div style="display: inline-block;  margin: 10px;" v-if="userDetails.userrole == 'admin'">
                                <b-form-checkbox v-model="parents_only" name="check-button" switch><b-badge variant="dark">Parents Only {{ ( (parents_only == true) ? '(on)': '(off)'  ) }}</b-badge></b-form-checkbox>
                            </div>

                            <b-button size="sm" variant="success" @click="loadInventory" :disabled="block_load_inventory">Reload</b-button>
                        </div>
                    </div>

                    <div v-if="block_load_inventory" style="text-align: center; padding: 20px;">
                        <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem;"></b-spinner>
                    </div>

                    <vue-good-table
                        v-show="inventory.length > 0"
                        :columns="inventory_columns"
                        @on-cell-click="onInventoryColumnClick"
                        :rows="inventory"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            position: 'top',
                            perPage: 20
                          }"
                        :search-options="{
                            enabled: true,
                            trigger: 'enter'
                        }"
                        :select-options="{ enabled: false }"
                        styleClass="vgt-table bordered condensed"
                    >
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'actions'">
                                <span>
                                    <span v-if="props.row.row_status == 'not added'">
                                        <b-button variant="success" size="sm">Save</b-button>
                                        <b-button variant="danger" size="sm">Remove</b-button>
                                    </span>

                                    <span v-else>

                                        <span v-if="inventory_being_updated == true">
                                            <b-button variant="outline-primary" size="sm" disabled>
                                                <b-spinner small></b-spinner>
                                                Update
                                            </b-button>
                                        </span>

                                        <span v-else>
                                            <span v-if="userDetails.userrole == 'admin'">
                                                <b-button variant="outline-primary" size="sm">
                                                    Update
                                                </b-button>
                                            </span>
                                        </span>

                                        <b-button variant="outline-primary" size="sm" style="visibility: hidden;"> </b-button>
                                    </span>
                                </span>
                            </span>

                            <span v-else-if="props.column.field == 'nitems'">
                                <span v-if="props.row.row_status == 'not added'">
                                    <b-input size="sm" style="margin: auto; width: 100px;" v-model="inventory[props.row.originalIndex].nitems" type="number" min="0"></b-input>
                                </span>
                                <span v-else>
                                    <div style="text-align: center;">
                                        <b-button size="sm" style="font-size: 10px;" variant="outline-danger" v-show="userDetails.userrole  == 'admin'">
                                            <b>-</b>
                                        </b-button>

                                        <div style="background: #efefef; display: inline-block; padding: 4px;">
                                            <b>{{ inventory[props.row.originalIndex].nitems }}</b>
                                        </div>

                                        <b-button size="sm" style="font-size: 10px;" variant="outline-success" v-show="userDetails.userrole  == 'admin'">
                                            <b>+</b>
                                        </b-button>
                                    </div>
                                </span>
                            </span>

                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                    </vue-good-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "AddInventory",
        props: ["showbacker"],
        components: {Backer,Multiselect,VueGoodTable},
        data: function(){
            return {
                userDetails: {},
                location_id: null,
                sublocation_id: null,
                block_load_inventory: false,
                categories: [],
                vendors: [],
                statuses: [
                    {value: "active", text: "ACTIVE"},
                    {value: "discontinued", text: "DISCONT."},
                ],
                locations: [],
                sublocations: [],
                inventory: [],
                
                parents_only: true,
                inventory_columns: [
                    {
                        label: "ID",
                        field: "product_id",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "Product",
                        field: "product_name",
                        filterable: true,
                        sortable: false,
                    },
                    {
                        label: "SKU",
                        field: "product_sku",
                        filterable: true,
                        sortable: false,
                    },
                    {
                        label: "In Stock",
                        field: "nitems",
                        filterable: false,
                        sortable: true,
                    },
                    
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                ],
                block_search: false,
                block_submit: false,
                searched_products: [],
                searched_products_columns: [
                    {
                        label: "ID",
                        field: "product_id",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Name",
                        field: "product_name",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "SKU",
                        field: "product_sku",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Quantity",
                        field: "quantity",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                ],
                search_keyword: null,
                search_opened: false,
                inventory_being_updated: false,
                init_add_items: false,
                init_add_special_items: false,
                special_product: {},
            }
        },
        methods: {
            showParentChild: function(e){
                if (e){
                    e.preventDefault();
                }

                this.showing_parents = !this.showing_parents;
                if (this.showing_parents == true){
                    this.inventory = this.only_parents;
                }
                else {
                    this.inventory = this.all_inventory;
                }
            },
            onSearchedProductsColumnClick: function(params){
                let action = params.event.target.innerText;
                if (action === "Add") {
                    this.addRow(params.row);
                }
            },
            onInventoryColumnClick: function(params){
                let action = params.event.target.innerText;
                if (action === "Save") {
                    this.saveInventoryItem(params.row, "save");
                }
                if (action === "Update") {
                    this.saveInventoryItem(params.row, "update");
                }
                if (action === "Remove") {
                    let value = params.row.idx;
                    this.removeRow(value);
                }
                if (action === "+") {
                    this.inventory[params.row.originalIndex].nitems += 1
                }
                if (action === "-") {
                    this.inventory[params.row.originalIndex].nitems -= 1
                    this.inventory[params.row.originalIndex].nitems = Math.max(this.inventory[params.row.originalIndex].nitems, 0);
                }
            },
            removeFromChildren: function(product){
                let filtered = this.data.children.filter(function(d){
                    return d.child_product_id != product.child_product_id;
                });
                this.data.children = filtered;
            },
            loadInventory: function(e){
                if (e){
                    e.preventDefault();
                }
                if (!this.location_id || !this.sublocation_id){
                    this.$bvToast.toast(
                        "Please select a location / sublocation.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning  "}
                    );
                    return
                }

                let temp_inventory = JSON.parse(JSON.stringify(this.inventory));
                this.inventory = [];
                let that = this;
                let path = "/api/inventory/get_inventory_for_location_sublocation/"
                let data = {"location_id": this.location_id, "sublocation_id": this.sublocation_id, "parents_only": this.parents_only}
                console.log(data);

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        setTimeout(function(){ 
                            that.block_load_inventory = false;
                            that.inventory = temp_inventory;
                        }, 1000);                       
                    }
                    else {
                        setTimeout(function(){ 
                            that.inventory = response.data.result;
                            that.block_load_inventory = false;
                        }, 1000);   
                    }
                    
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading inventory", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    setTimeout(function(){ 
                        that.block_load_inventory = false;
                        that.inventory = temp_inventory;
                    }, 1000);
                }

                this.block_load_inventory = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            removeRow: function(idx){
                let inventory_temp = this.inventory.filter(function(d){return d.idx != idx});
                this.inventory = inventory_temp;
            },
            addRow: function(product){
                let product_id = product.product_id;
                let exists = this.inventory.filter(function(d){
                    return d.product_id == product_id;
                });

                if (exists.length > 0){
                    this.$bvToast.toast(
                        "Product already exists in the inventory. Please increment its count.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                if (isNaN(parseFloat(product.quantity)) || product.quantity == null || isNaN(product.quantity)) {
                    this.$bvToast.toast(
                        "Cannot add a non-numeric product quantity to inventory", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                let idx = 0;
                if (this.inventory.length > 0){
                    idx = this.inventory[0].idx+1;
                }

                let p = {
                    product_id: product.product_id,
                    product_name: product.product_name,
                    product_sku: product.product_sku,
                    nitems: parseFloat(product.quantity),
                    row_status: 'not added',
                    idx: idx
                }
                this.inventory.splice(0,0, p);
            },
            searchProducts: function(e){
                if (e){
                    e.preventDefault();
                }
                if (!this.search_keyword || this.search_keyword.length < 2){
                    this.$bvToast.toast(
                        "Please search with a more specific keyword", 
                        {title: "Incomplete Search", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                let that = this;
                let path = "/api/product/search_product_v2/"
                let data = {keyword: this.search_keyword}

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else{

                        that.searched_products = response.data.result;
                        if (that.searched_products.length == 0){
                            that.$bvToast.toast(
                                "No products found matching keyword: '"+that.search_keyword+"'", 
                                {title: "No result", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                    that.block_search=false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.block_search=false;
                }
                this.block_search = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            saveSpecialInventoryItem(row, action) {
                let item = {
                    location_id: this.location_id,
                    sublocation_id: this.sublocation_id,
                    product_id: (row.id || -1),
                    product_sku: row.product_sku,
                    nitems: parseInt(row.nitems)
                }

                let that = this;
                let path;
                if (action == "save") {
                    path = "/api/inventory/add_sp_products_to_inventory/";
                }
                else if (action == "update") {
                    path = "/api/inventory/overwrite_sp_products_to_inventory/";
                }

                if (isNaN(item.nitems) || item.nitems == null){
                    this.$bvToast.toast(
                        "Cannot add a non-numeric product quantity to inventory", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                let idx = row.idx;
                let origidx = row.originalIndex;
                this.inventory_being_updated = true;

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        setTimeout(function(){ 
                            that.inventory_being_updated = false;
                        }, 1500);

                    }
                    else {
                        // that.inventory[origidx] = response.data.result;
                        that.inventory[origidx].row_status = "added"
                        let temp_inventory = JSON.parse(JSON.stringify(that.inventory));
                        setTimeout(function(){ 
                            that.inventory_being_updated = false;
                        }, 1500);

                        if (action == "save"){
                            that.$bvToast.toast(
                                "Saved product to inventory.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        else if (action == "update"){
                            that.$bvToast.toast(
                                "Updated product count in inventory.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        
                        that.inventory = [];
                        that.inventory = temp_inventory;
                        //that.loadInventory()
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error adding product to inventory. Please try again", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    setTimeout(function(){ 
                        that.inventory_being_updated = false;
                    }, 1500);
                }
                Requestor.postAsyncP(path, item, this, s, f);
            },
            saveInventoryItem: function(row, action){
                let item = {
                    location_id: this.location_id,
                    sublocation_id: this.sublocation_id,
                    product_id: row.product_id,
                    product_sku: row.product_sku,
                    nitems: parseInt(row.nitems)
                }

                console.log(item);

                //special item
                if (item.product_id == -1 || item.product_id == null || item.product_id == undefined ){
                    this.saveSpecialInventoryItem(row, action);
                    return
                }

                if (item.product_sku == null || item.product_sku == undefined ){
                    this.$bvToast.toast(
                        "Cannot add a product with missing sku.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                if (isNaN(item.nitems) || item.nitems == null || item.nitems == undefined ){
                    this.$bvToast.toast(
                        "Cannot add a non-numeric product quantity to inventory", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }
                
                let that = this;
                let path;

                if (action == "save") {
                    path = "/api/inventory/add_single_product_to_inventory/";
                }
                else if (action == "update") {
                    path = "/api/inventory/update_single_product_to_inventory/";
                }
                let idx = row.idx;
                let origidx = row.originalIndex;

                let data = { 
                    "product_id": item.product_id, 
                    "product_sku": item.product_sku,
                    "location_id": this.location_id, 
                    "sublocation_id": this.sublocation_id, 
                    "nitems": item.nitems 
                };
                this.inventory_being_updated = true;

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        setTimeout(function(){ 
                            that.inventory_being_updated = false;
                        }, 1500);

                    }
                    else {
                        // that.inventory[origidx] = response.data.result;
                        that.inventory[origidx].row_status = "added"
                        let temp_inventory = JSON.parse(JSON.stringify(that.inventory));
                        setTimeout(function(){ 
                            that.inventory_being_updated = false;
                        }, 1500);

                        if (action == "save"){
                            that.$bvToast.toast(
                                "Saved product to inventory.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        else if (action == "update"){
                            that.$bvToast.toast(
                                "Updated product count in inventory.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        
                        that.inventory = [];
                        that.inventory = temp_inventory;
                        //that.loadInventory()
                        
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error adding product to inventory. Please try again", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    setTimeout(function(){ 
                        that.inventory_being_updated = false;
                    }, 1500);
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            reset: function(e){
                if (e){
                    e.preventDefault();
                }
                this.data = {
                    product_name: null,
                    sku: null,
                    vendor_id: null,
                    category_id: null,
                    selling_price: 0.0,
                    status: "active",
                    children: []
                };
                this.searched_children = [];
                this.search_keyword = null;

            },
            reset_inventory: function(picked){
                this.inventory = [];
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });

                                if (that.userDetails.userrole == "locationadmin" || that.userDetails.userrole == "locationuser"){
                                    let location_id = parseInt(that.userDetails.properties['location_id']);
                                    that.locations =  that.locations.filter(function(d){return d.value == location_id});
                                    console.log(that.locations)
                                }
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                    
                }
            },
            initAddItems: function(e){
                if (e){
                    e.preventDefault();
                }

                this.searched_products = [];
                this.search_keyword = null;
                this.init_add_items = !this.init_add_items;
            },
            initAddSpecialItems: function(e){
                if (e){
                    e.preventDefault();
                }
                this.special_product = {};
                this.init_add_special_items = !this.init_add_special_items;
            },
            addSpecialProduct: function(e){
                if (e){
                    e.preventDefault();
                }

                let p = {
                    id: -1,
                    product_name: this.special_product.product_name,
                    product_sku: ( this.special_product.sku + " | " + this.special_product.vendor),
                    nitems: 0,
                    row_status: 'not added',
                    idx: idx
                }
                let idx = 0;
                if (this.inventory.length > 0){
                    idx = this.inventory[0].idx+1;
                }
                this.inventory.splice(0, 0, p);
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                if (this.userDetails.userrole == "admin" || this.userDetails.userrole == "locationadmin" || this.userDetails.userrole == "locationuser"){
                    this.fetch_prereqs();
                }
                else {
                    this.$router.replace({"path":  "/"})
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/AddInventory.vue